import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate, getLocale } from "react-i18nify";
import { QRCode } from "react-qrcode-logo";

import { useKioskHorizontalStyles } from "./../../../../kioskstyles";

import "react-phone-number-input/style.css";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

let env = require("./../../../../env");

// props has activeStep
export default function QuickStartElement({}) {
  const {} = useContext(KioskContext);

  const { qrCode, getKioskTheme } = useContext(SocketIOContext);

  const kiosktheme = getKioskTheme();
  const kioskstyles = useKioskHorizontalStyles();

  return (
    <div
      class="ks_blackCornedDiv ks_blackCornedDivMarginForSubtitle"
      style={{
        ...kioskstyles.blackCornedDiv,
        ...kioskstyles.blackCornedDivMarginForSubtitle
      }}
    >
      <div
        class="ks_row"
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%"
        }}
      >
        <div>
          <div id="qrelement" style={kioskstyles.phonenumber.qrelement}>
            <QRCode
              style={{
                height: "auto",
                width: "auto",
                maxWidth: "100%",
                maxHeight: "100%"
              }}
              size="600"
              fgColor={kioskstyles.phonenumber.quickStartQRCodeColor}
              bgColor={kioskstyles.phonenumber.quickStartQRBGColor}
              //logoImage="/img/ca.svg"
              logoImage={
                env.REACT_APP_API_ENDPOINT +
                "/kiosk/getImage/QRLogo" +
                "?t=" +
                kiosktheme.lastUpdatedImgETag
              }
              qrStyle="dots"
              removeQrCodeBehindLogo="true"
              eyeRadius={{ outer: 5, inner: 1 }}
              logoPadding="3"
              value={
                env.CAAPP_URL +
                "/qs/" +
                qrCode +
                "?lang=" +
                getLocale().toLowerCase()
              }
            />
          </div>
        </div>
        <div style={kioskstyles.phonenumber.qrdiv}>
          <span class="fontBold" style={kioskstyles.phonenumber.qrtitleelement}>
            <Translate value="application.theme.quickStartQRHeader" />
          </span>

          <span
            class="fontNormal"
            style={kioskstyles.phonenumber.qrbodyelement}
          >
            <br />

            <br />
            <Translate value="application.theme.quickStartQRBody" />
          </span>
        </div>
      </div>
    </div>
  );
}
